import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-出入库记录",
  "use": "icon-出入库记录-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-出入库记录\">\r\n    <path d=\"M438.77 288.03H259.7v89.53h179.07v-89.53zM707.38 467.1H259.7v89.53h447.67V467.1zM80.63 64.19v895.35h805.81V64.19H80.63zM796.91 870H170.17V153.73h626.74V870z m-89.53-223.83H259.7v89.53h447.67v-89.53z\" p-id=\"10427\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol